function DummyCache() {}

DummyCache.prototype.get = function (key) {
  return null;
};

DummyCache.prototype.has = function (key) {
  return false;
};

DummyCache.prototype.set = function (key, value) {
};

module.exports = DummyCache;



//////////////////
// WEBPACK FOOTER
// ./~/idtoken-verifier/src/helpers/dummy-cache.js
// module id = 263
// module chunks = 0